/** @format */

import React from 'react';
import { Redirect } from 'react-router-dom';
import { pharmacyFeatures } from '../../../v2-config/constants/pharmacy-features.constant';

export default function PharmacyFeatureGuard({ feature, children }) {
	if (!pharmacyFeatures[feature]) {
		return <Redirect to="/" />;
	}
	return <>{children}</>;
}
